const PermissionInput = ({ section, type = "text", value, onChange, style, canEditField, getFieldStyle, ...props }) => {
  const canEdit = canEditField(section);
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => canEdit && onChange(e)}
      disabled={!canEdit}
      style={getFieldStyle(section, style)}
      {...props}
    />
  );
};

export default PermissionInput;